export const token = {
    colorPrimary: '#B10000',
}

export const components = {
    Table: {
        borderColor: '#B10000',
        headerBg: '#FFFFFF',
        rowHoverBg: 'rgba(232, 232, 232, 0.5)'
    },
    Select: {
        multipleItemBorderColor: '#B10000',
        multipleItemBorderWidth: '0.2px',
        multipleItemBorderColorDisabled: 'rgb(172, 0, 0)',
        multipleItemBg: '#FFFFFF',

    }

}